export default class LocalStorageService {
    public saveReferencesListFilters(filters: any) {
        if (filters) {
            localStorage.setItem('referencesListFilters', JSON.stringify(filters));
        }
    }

    public getReferencesListFilters(): any | undefined {
        const filters = localStorage.getItem('referencesListFilters');
        if (filters) {
            return JSON.parse(filters);
        }

        return undefined;
    }

    public clearReferencesListFilters() {
        localStorage.removeItem('referencesListFilters');
    }
}

export const localStorageService = new LocalStorageService();
